import React, { useRef } from 'react';

interface DateRangeInputProps {
    fromDate?: string;
    toDate?: string;
    onFromDateChange: (date: string) => void;
    onToDateChange: (date: string) => void;
    fromLabel?: string;
    toLabel?: string;
    fromPlaceholder?: string;
    toPlaceholder?: string;
    className?: string;
    required?: boolean;
    minDate?: string;
    maxDate?: string;
}

const DateRangeInput: React.FC<DateRangeInputProps> = ({
    fromDate = '',
    toDate = '',
    onFromDateChange,
    onToDateChange,
    fromLabel = 'From',
    toLabel = 'To',
    fromPlaceholder = 'Select start date',
    toPlaceholder = 'Select end date',
    className = '',
    required = false,
    minDate,
    maxDate,
}) => {
    const fromInputRef = useRef<HTMLInputElement>(null);
    const toInputRef = useRef<HTMLInputElement>(null);

    const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newFromDate = e.target.value;
        onFromDateChange(newFromDate);
        if (toDate && newFromDate > toDate) {
            onToDateChange(newFromDate);
        }
    };

    const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newToDate = e.target.value;
        onToDateChange(newToDate);
    };

    return (
        <div className={`flex flex-col gap-4 ${className}`}>
            <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-gray-700">
                    {fromLabel}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>

                <div
                    className="relative w-full"
                    onClick={() => fromInputRef.current?.showPicker()}
                >
                    <input
                        ref={fromInputRef}
                        type="date"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        placeholder={fromPlaceholder}
                        required={required}
                        min={minDate}
                        max={maxDate}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg
                                   focus:outline-none focus:ring-2 focus:ring-blue-500
                                   focus:border-transparent transition-all duration-200
                                   text-sm font-montserrat cursor-pointer bg-white"
                    />
                </div>
            </div>

            <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-gray-700">
                    {toLabel}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>

                <div
                    className="relative w-full"
                    onClick={() => toInputRef.current?.showPicker()}
                >
                    <input
                        ref={toInputRef}
                        type="date"
                        value={toDate}
                        onChange={handleToDateChange}
                        placeholder={toPlaceholder}
                        required={required}
                        min={fromDate || minDate}
                        max={maxDate}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg
                                   focus:outline-none focus:ring-2 focus:ring-blue-500
                                   focus:border-transparent transition-all duration-200
                                   text-sm font-montserrat cursor-pointer bg-white"
                    />
                </div>
            </div>
        </div>
    );
};

export default DateRangeInput;
